module.exports = __webpack_public_path__ + "img/MEDIA109.ecc289a3.jpg";